import { GDSInputStatus } from '@leagueplatform/genesis-core';

export function isNotSuccessValidationStatus(
  statusType: GDSInputStatus,
): boolean {
  return statusType === 'error' || statusType === 'warning';
}
